import { WarningFilled } from "@ant-design/icons";

export default function Error({ error }: any) {
  return (
    <div className="flex justify-center items-center">
      <div className="flex flex-col items-center my-20">
        <div className="flex items-center">
          <WarningFilled size={40} color="#9ca3af" />
        </div>
        <div className="text-black">{error}</div>
      </div>
    </div>
  );
}
